import { type FC, useState, useEffect } from 'react';

import { GenericButton, GenericCheckbox } from '@shared/components/ui/custom';

interface FilteringModalFooterProps {
  onReset: () => void;
  applyDisabled?: boolean;
  resetDisabled?: boolean;
  onCloseAfterApplyChange?: (checked: boolean) => void;
}

export const FilteringModalFooter: FC<FilteringModalFooterProps> = ({
  onReset,
  applyDisabled,
  resetDisabled,
  onCloseAfterApplyChange,
}) => {
  const [closeAfterApply, setCloseAfterApply] = useState(true);

  useEffect(() => {
    onCloseAfterApplyChange?.(closeAfterApply);
  }, [closeAfterApply, onCloseAfterApplyChange]);

  const labelClassName = applyDisabled ? 'text-neutral-500 cursor-not-allowed' : 'text-white cursor-pointer';

  return (
    <div
      className="flex justify-between border-t border-neutral-800 py-3 px-4 items-center"
      data-testid="trace-findings-filtering-modal-footer"
    >
      <GenericCheckbox
        checked={closeAfterApply}
        onCheckedChange={setCloseAfterApply}
        label="Close After Applying"
        disabled={!!applyDisabled}
        labelClassName={labelClassName}
        data-testid="trace-findings-filtering-modal-close-after-applying"
      />
      <div className="flex gap-2 justify-end ">
        <GenericButton
          type="button"
          variant="secondary"
          className="px-3 py-1 rounded text-sm border border-neutral-600 bg-neutral-700 text-white hover:bg-neutral-600 disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={onReset}
          label="Reset"
          data-testid="trace-findings-filtering-modal-reset-button"
          disabled={resetDisabled}
        />
        <GenericButton
          type="submit"
          variant="default"
          className="px-3 py-1 rounded text-sm border border-primary bg-primary text-white hover:bg-primary/80 disabled:opacity-50 disabled:cursor-not-allowed"
          disabled={applyDisabled}
          label="Apply"
          data-testid="trace-findings-filtering-modal-apply-button"
        />
      </div>
    </div>
  );
};
